import React, { useState } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import "./style.scss"

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [error, setError] = useState({ open: false, message: "" });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("")

  const parameters = queryString.parse(location.search);
  parameters.idp = 'onix5';

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({ open: false, message: "" })


    api.userPassLogin({ username, password },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        if (_translate) {
          setMessage(_translate);
        } else if (error.details) {
          setMessage(error.details);
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <>
      <Form onSubmit={(event) => onSubmit(event)} className="onix5-login">
        <div className="onix5-wrapper">
          <div className="onix5-form-group">
            <div className="onix5-form-content">
              <div>
                <img src="https://sp-logos.tbxnet.com/onix5.png" alt="Onix5" />
              </div>
              <div className="onix5-form-container onix5-form-container-login">
                <Input
                  className="onix5-input"
                  disabled={onLogin}
                  placeholder={translate("PlaceholderUserName")}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  name="login"
                  id="login"
                  onChange={e => setUsername(e.target.value)}
                />
              </div>
              <div className="onix5-form-container">
                <Input
                  className="onix5-input"
                  required={true}
                  disabled={onLogin}
                  placeholder={translate("PlaceholderPassword")}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  name="login"
                  onChange={e => setPassword(e.target.value)}
                />
              </div>
              <div className="onix5-button">
                {!onLogin ? (
                  <button type="submit" disabled={!props.turnstileSuccess}>
                    <span className="onix5-enter-text">
                      {translate("ButtonEnter")}
                    </span>
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </div>
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
